var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('UgTableCell',{staticClass:"lightUgTableCell",class:{ 'lightUgTableCell--disabled': _vm.disabled },attrs:{"width":_vm.width},on:{"mouse-enter":_vm.onMouseEnter,"mouse-leave":_vm.onMouseLeave,"click":event => !_vm.disabled && _vm.onClick(event)}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }